import { Box, VStack, Heading, useToast, Center } from "@chakra-ui/react";
import SeasonClawPrizeForm from "./Form";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../../consts/routes";
import useClawPrizes from "./hooks/useClawPrizes";
import { SeasonFormData } from "@olagg/validation-schemas/season.schema";

const CreateSeasonClawPrize = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { id: gameSeasonId } = useParams<{ id: string }>()
  const { createClawPrize } = useClawPrizes();

  const onSubmit = async (dataForm: SeasonFormData) => {
    try {
      await createClawPrize({...dataForm, game_season_id: gameSeasonId});
      toast({
        title: 'Premio de Máquina de Garra',
        colorScheme: 'olaggPink',
        status: 'success',
        description: `Premio de Máquina de Garra creado con éxito`,
        position: 'bottom-right'
      });
      navigate(`/seasons/${gameSeasonId}/claw-machine-prizes`);
    } catch (error: any) {
      toast({
        title: 'Error',
        colorScheme: 'olaggYellow',
        status: 'error',
        description: error.message || 'Error al crear el premio de máquina de garra',
        position: 'bottom-right'
      });
    }
  };

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Crear Premio de Máquina de Garra</Heading>
        <SeasonClawPrizeForm onSubmit={onSubmit} />
      </VStack>
    </Center>
  );
};

export default CreateSeasonClawPrize;